module.exports = __webpack_public_path__ + "static/4-efaf25454b94c12e8acc8d716ff41fb5.jpg";